import routerOptions0 from "D:/mysrc/esoft-web/esoft-official-website/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "D:/mysrc/esoft-web/esoft-official-website/src/router.options.ts";
import routerOptions2 from "D:/mysrc/esoft-web/esoft-official-website/src/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = routerOptions2.hashMode ?? routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
...routerOptions2,
}